// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* STORYBOOK
* If you add any variable, remember to map it into the proper Story
*/
/**
* Color palette - Facile.it
* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1
*/
/* Primary */
/* Action */
/* Alert */
/* Success */
/* Help */
/* Error */
/* Chick */
/* Text */
/* Grey */
/* Neutral/warm */
/* Neutral/cold */
/* Opacity/Grey */
/* Opacity/White */
/* Opacity/Colors */
/**
* Color map - Facile.it
*/
/**
* @deprecated use Color - Facile.it palette
*/
/**
* Removes a specific item from a list.
*
* @param {list} \$list List. @param {integer} \$index Index.
* @return {list} Updated list.
*/
/**
* Gets a value from a map.
*
* @param {map} \$map Map.
* @return {string} Value.
*/
.shark .scroll-lock.parent {
  width: 100%;
}
.shark .scroll-lock-parent {
  width: 100%;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjcm9sbExvY2suY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Q0FHQztBQUNEOzs7Q0FHQztBQUNELFlBQVk7QUFDWixXQUFXO0FBQ1gsVUFBVTtBQUNWLFlBQVk7QUFDWixTQUFTO0FBQ1QsVUFBVTtBQUNWLFVBQVU7QUFDVixTQUFTO0FBQ1QsU0FBUztBQUNULGlCQUFpQjtBQUNqQixpQkFBaUI7QUFDakIsaUJBQWlCO0FBQ2pCLGtCQUFrQjtBQUNsQixtQkFBbUI7QUFDbkI7O0NBRUM7QUFDRDs7Q0FFQztBQUNEOzs7OztDQUtDO0FBQ0Q7Ozs7O0NBS0M7QUFDRDtFQUNFLFdBQVc7QUFDYjtBQUNBO0VBQ0UsV0FBVztBQUNiIiwiZmlsZSI6InNjcm9sbExvY2suY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4qIFNUT1JZQk9PS1xuKiBJZiB5b3UgYWRkIGFueSB2YXJpYWJsZSwgcmVtZW1iZXIgdG8gbWFwIGl0IGludG8gdGhlIHByb3BlciBTdG9yeVxuKi9cbi8qKlxuKiBDb2xvciBwYWxldHRlIC0gRmFjaWxlLml0XG4qIGh0dHBzOi8vd3d3LmZpZ21hLmNvbS9kZXNpZ24vcHlKZUxGTmMzdHBGdDVOa1dwYnQ4bi9Db3JlLUZvdW5kYXRpb24tJTVCMS4xJTVEP25vZGUtaWQ9My00MjE5JnQ9RGpndFNlRThOZ0dheHBGbS0xXG4qL1xuLyogUHJpbWFyeSAqL1xuLyogQWN0aW9uICovXG4vKiBBbGVydCAqL1xuLyogU3VjY2VzcyAqL1xuLyogSGVscCAqL1xuLyogRXJyb3IgKi9cbi8qIENoaWNrICovXG4vKiBUZXh0ICovXG4vKiBHcmV5ICovXG4vKiBOZXV0cmFsL3dhcm0gKi9cbi8qIE5ldXRyYWwvY29sZCAqL1xuLyogT3BhY2l0eS9HcmV5ICovXG4vKiBPcGFjaXR5L1doaXRlICovXG4vKiBPcGFjaXR5L0NvbG9ycyAqL1xuLyoqXG4qIENvbG9yIG1hcCAtIEZhY2lsZS5pdFxuKi9cbi8qKlxuKiBAZGVwcmVjYXRlZCB1c2UgQ29sb3IgLSBGYWNpbGUuaXQgcGFsZXR0ZVxuKi9cbi8qKlxuKiBSZW1vdmVzIGEgc3BlY2lmaWMgaXRlbSBmcm9tIGEgbGlzdC5cbipcbiogQHBhcmFtIHtsaXN0fSAkbGlzdCBMaXN0LiBAcGFyYW0ge2ludGVnZXJ9ICRpbmRleCBJbmRleC5cbiogQHJldHVybiB7bGlzdH0gVXBkYXRlZCBsaXN0LlxuKi9cbi8qKlxuKiBHZXRzIGEgdmFsdWUgZnJvbSBhIG1hcC5cbipcbiogQHBhcmFtIHttYXB9ICRtYXAgTWFwLlxuKiBAcmV0dXJuIHtzdHJpbmd9IFZhbHVlLlxuKi9cbi5zaGFyayAuc2Nyb2xsLWxvY2sucGFyZW50IHtcbiAgd2lkdGg6IDEwMCU7XG59XG4uc2hhcmsgLnNjcm9sbC1sb2NrLXBhcmVudCB7XG4gIHdpZHRoOiAxMDAlO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./node_modules/@facile-it/shark-morph/components/ScrollLock/scrollLock.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;CAGC;AACD,YAAY;AACZ,WAAW;AACX,UAAU;AACV,YAAY;AACZ,SAAS;AACT,UAAU;AACV,UAAU;AACV,SAAS;AACT,SAAS;AACT,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;AACnB;;CAEC;AACD;;CAEC;AACD;;;;;CAKC;AACD;;;;;CAKC;AACD;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,otDAAotD","sourcesContent":["/**\n* STORYBOOK\n* If you add any variable, remember to map it into the proper Story\n*/\n/**\n* Color palette - Facile.it\n* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1\n*/\n/* Primary */\n/* Action */\n/* Alert */\n/* Success */\n/* Help */\n/* Error */\n/* Chick */\n/* Text */\n/* Grey */\n/* Neutral/warm */\n/* Neutral/cold */\n/* Opacity/Grey */\n/* Opacity/White */\n/* Opacity/Colors */\n/**\n* Color map - Facile.it\n*/\n/**\n* @deprecated use Color - Facile.it palette\n*/\n/**\n* Removes a specific item from a list.\n*\n* @param {list} $list List. @param {integer} $index Index.\n* @return {list} Updated list.\n*/\n/**\n* Gets a value from a map.\n*\n* @param {map} $map Map.\n* @return {string} Value.\n*/\n.shark .scroll-lock.parent {\n  width: 100%;\n}\n.shark .scroll-lock-parent {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
